<template>
  <div class="fixed-menu d-lg-none">
    <div class="fixed-menu-body">
      <div class="btn-hint">
        <a href="mailto:support@brandly.com">Need help?</a>
      </div>
      <button :class="`btn-${actionParams.variant} sidebar-purchase-link`" @click="$emit('action')">
        {{actionParams.button}}
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['actionParams']
}
</script>



// WEBPACK FOOTER //
// src/components/pages/editor/FixedMenu.vue